import { forwardRef } from "react";
function SvgClasslinkSvg({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={53}
      height={43}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect width={53} height={43} fill="#fff" rx={6} />
      <path
        fill="#0A4D7F"
        d="M16.774 23.924h-.007c-1.72 1.99-.008 2.935-.008 2.935.059.032.127.058.194.084a8.262 8.262 0 0 1-.18-3.02ZM27.989 26.503c-1.346.926-2.918 4.02-2.918 4.02l-.813-.008c.532-1.182.868-2.157 1.069-2.963-.207.07-.323.105-.323.105-1.621.56-3.265.853-4.727.872 1.538 2.327 4.338 2.742 4.338 2.742 3.936.537 6.921-1.648 8.525-3.233-3.315-1.829-5.151-1.535-5.151-1.535Z"
      />
      <path
        fill="#0A4D7F"
        d="M40.74 17.913s2.59-6.544-3.345-11.03c0 0-9.508-6.343-14.821 4.253 0 0-3.803-3.853-8.492-.864-4.01 2.557-3.344 6.011-2.983 7.74 0 0-7.57 2.255-7.181 10.43.29 6.091 6.085 7.922 8.341 8.407.495.105.997.154 1.502.154H38.61c.488 0 .974-.047 1.452-.146 2.27-.465 8.144-2.298 8.035-8.764-.138-8.008-7.357-10.18-7.357-10.18ZM24.422 32.584c-5.03-.058-6.815-3.887-6.815-3.887a9.015 9.015 0 0 1-.275-.607c-1.382-.52-2.197-1.507-2.007-2.976.192-1.485 1.834-2.935 1.834-2.935.957-3.001 3.108-5.055 3.108-5.055s1.806-1.956 3.773-2.957l3.423.538c-7.763 3.206-8.16 9.841-8.16 9.841-.05.997.07 1.85.302 2.577.58-.043 1.002-.107 1.002-.107a19.738 19.738 0 0 0 4.97-1.443c-.047-1.305-.635-1.631-.635-1.631s-.705-.815-3.596-1.293l.277-.39s1.433.325 3.049.01c1.762-.343 3.376-1.567 5.166-4.067l.868-.038c-1.758 2.367-1.88 4.152-1.585 5.33 1.752-1.323 2.58-2.485 2.58-2.485 3.159-4.481-1.23-3.8-1.23-3.8l1.321-1.582c6.708 1.475.551 7.624.551 7.624a14.74 14.74 0 0 1-2.294 1.926c.116.124 1.278 1.338 3.507 2.427.588-.633.898-1.092.898-1.092l.883.161c-5.242 6.392-10.915 5.911-10.915 5.911Zm2.384-12.767a1.428 1.428 0 0 1-1.382 1.37 1.423 1.423 0 0 1-1.44-1.497 1.428 1.428 0 0 1 1.38-1.37c.816-.017 1.476.667 1.442 1.497Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClasslinkSvg);
export default ForwardRef;
